/**
 * Subway District — baked by ultra_map_editor. Edit via the editor.
 *
 * Do not hand-edit: this file is regenerated wholesale on the next bake, and
 * hand-written comments/formatting do not survive a bake.
 */
import type { WorldData } from '../../types';

export const map: WorldData = {
  cityName: "Subway District",
  ground: { width: 76, depth: 76 },
  spawnPoint: { x: 0, z: 32 },
  groundTexture: { textureUrl: "/textures/ground-realistic.webp", textureScale: 0.16, textureRotation: 0, secondaryUrl: "/textures/ground-stylized.webp", secondaryScale: 0.11, secondaryRotation: 0.82, noiseUrl: "/textures/noise-detailed.webp", noiseScale: 0.05, noiseRotation: -0.4, noiseOffset: -0.06, noiseGain: 0.9 },

  objects: [
    {
      id: "sd-station",
      kind: "building",
      label: "Station Entrance",
      position: { x: -6, z: -14 },
      size: { w: 11.761, d: 7.199, h: 6.2 },
      color: 0x6a5c4a,
      interactable: false,
      modelUrl: "/models/buildings/building_settlement_market.glb",
      rotationY: 0.1,
    },
    {
      id: "sd-shelter",
      kind: "building",
      label: "Platform Shelter",
      position: { x: 14, z: -6 },
      size: { w: 5.178, d: 7.183, h: 3.4 },
      color: 0x6a5c4a,
      interactable: false,
      modelUrl: "/models/buildings/building_shack_a.glb",
      rotationY: -1.2,
    },
    {
      id: "sd-office",
      kind: "building",
      label: "Ticket Office",
      position: { x: -19, z: 6 },
      size: { w: 7.262, d: 9.007, h: 4.6 },
      color: 0x6a5c4a,
      interactable: false,
      modelUrl: "/models/buildings/building_house_dilapidated.glb",
      rotationY: 0.6,
    },
    {
      id: "sd-generator",
      kind: "prop",
      label: "Dead Generator",
      position: { x: 8, z: 12 },
      size: { w: 3.2, d: 2.753, h: 2.681 },
      color: 0x6a5c4a,
      interactable: true,
      lootObjectId: "raid_subway_district:sd-generator",
      modelUrl: "/models/objects/obj_generator-large.glb",
      rotationY: 1.5,
    },
    {
      id: "sd-rail-1",
      kind: "prop",
      label: "Torn Rail",
      position: { x: -2, z: 20 },
      size: { w: 2.36, d: 5.999, h: 0.484 },
      color: 0x6a5c4a,
      interactable: false,
      modelUrl: "/models/objects/obj_rail-1.glb",
      rotationY: 0,
    },
    {
      id: "sd-rail-2",
      kind: "prop",
      label: "Torn Rail",
      position: { x: 4, z: 22 },
      size: { w: 6, d: 3.057, h: 0.9 },
      color: 0x6a5c4a,
      interactable: false,
      modelUrl: "/models/objects/obj_rail-2.glb",
      rotationY: 0.2,
    },
    {
      id: "subway_district-row1-1",
      kind: "prop",
      label: "Wreck Row Car",
      position: { x: -21.876, z: -22.241 },
      size: { w: 4.3, d: 1.834, h: 1.414 },
      color: 0x6a5a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_car-rust-11.glb",
      collisionW: 4.3,
      collisionD: 1.834,
      rotationY: 4.686,
    },
    {
      id: "subway_district-row1-2",
      kind: "prop",
      label: "Stacked Wreck",
      position: { x: -21.694, z: -22.476 },
      size: { w: 1.817, d: 4.3, h: 1.376 },
      color: 0x6a5a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_car-rust-36.glb",
      rotationY: 3.117,
      noClip: true,
      positionY: 1.301,
    },
    {
      id: "subway_district-row1-3",
      kind: "prop",
      label: "Wreck Row Car",
      position: { x: -18.938, z: -21.917 },
      size: { w: 4.3, d: 1.821, h: 1.397 },
      color: 0x6a5a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_car-rust-12.glb",
      collisionW: 4.3,
      collisionD: 1.821,
      rotationY: 4.763,
    },
    {
      id: "subway_district-row1-4",
      kind: "prop",
      label: "Stacked Wreck",
      position: { x: -18.956, z: -21.725 },
      size: { w: 4.3, d: 1.792, h: 1.351 },
      color: 0x6a5a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_car-rust-41.glb",
      rotationY: 4.658,
      noClip: true,
      positionY: 1.285,
    },
    {
      id: "subway_district-row1-5",
      kind: "prop",
      label: "Wreck Row Car",
      position: { x: -16, z: -21.806 },
      size: { w: 1.838, d: 4.3, h: 1.321 },
      color: 0x6a5a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_car-rust-17.glb",
      collisionW: 1.838,
      collisionD: 4.3,
      rotationY: 3.201,
    },
    {
      id: "subway_district-row1-6",
      kind: "prop",
      label: "Wreck Row Car",
      position: { x: -13.062, z: -22.284 },
      size: { w: 1.817, d: 4.3, h: 1.376 },
      color: 0x6a5a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_car-rust-36.glb",
      collisionW: 1.817,
      collisionD: 4.3,
      rotationY: 3.115,
    },
    {
      id: "subway_district-row1-7",
      kind: "prop",
      label: "Wreck Row Car",
      position: { x: -10.124, z: -21.963 },
      size: { w: 4.3, d: 1.792, h: 1.351 },
      color: 0x6a5a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_car-rust-41.glb",
      collisionW: 4.3,
      collisionD: 1.792,
      rotationY: 4.731,
    },
    {
      id: "subway_district-row2-1",
      kind: "prop",
      label: "Wreck Row Car",
      position: { x: 18.005, z: 13.924 },
      size: { w: 4.5, d: 1.919, h: 1.479 },
      color: 0x6a5a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_car-rust-11.glb",
      collisionW: 4.5,
      collisionD: 1.919,
      rotationY: 4.033,
    },
    {
      id: "subway_district-row2-2",
      kind: "prop",
      label: "Wreck Row Car",
      position: { x: 21.855, z: 9.855 },
      size: { w: 4.5, d: 1.906, h: 1.462 },
      color: 0x6a5a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_car-rust-12.glb",
      collisionW: 4.5,
      collisionD: 1.906,
      rotationY: 3.816,
    },
    {
      id: "subway_district-row2-3",
      kind: "prop",
      label: "Wreck Row Car",
      position: { x: 26.17, z: 6.251 },
      size: { w: 1.923, d: 4.5, h: 1.383 },
      color: 0x6a5a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_car-rust-17.glb",
      collisionW: 1.923,
      collisionD: 4.5,
      rotationY: 2.366,
    },
    {
      id: "loot-1",
      kind: "loot",
      label: "Supply Crate",
      position: { x: -4.799, z: 9.435 },
      size: { w: 1.264, d: 1.264, h: 1.047 },
      color: 0x7a6544,
      interactable: true,
      lootObjectId: "raid_subway_district:cache-1",
      modelUrl: "/models/objects/obj_crate-wood.glb",
      rotationY: 2.429,
    },
    {
      id: "loot-2",
      kind: "loot",
      label: "Stacked Crates",
      position: { x: 8.785, z: 24.814 },
      size: { w: 1.536, d: 1.462, h: 0.844 },
      color: 0x7a6544,
      interactable: true,
      lootObjectId: "raid_subway_district:cache-2",
      modelUrl: "/models/objects/obj_crates.glb",
      rotationY: 5.195,
    },
    {
      id: "loot-3",
      kind: "loot",
      label: "Ammo Case",
      position: { x: -5.2537, z: 18.8848 },
      size: { w: 1.087, d: 0.991, h: 0.648 },
      color: 0x7a6544,
      interactable: true,
      lootObjectId: "raid_subway_district:cache-3",
      modelUrl: "/models/objects/obj_crates-2.glb",
      rotationY: 3.352,
    },
    {
      id: "loot-4",
      kind: "loot",
      label: "Dumped Barrel",
      position: { x: -11.628, z: 7.625 },
      size: { w: 1.136, d: 1.136, h: 1.525 },
      color: 0x7a6544,
      interactable: true,
      lootObjectId: "raid_subway_district:cache-4",
      modelUrl: "/models/objects/obj_barrel.glb",
      rotationY: 4.864,
    },
    {
      id: "loot-5",
      kind: "loot",
      label: "Toolbox",
      position: { x: 2.515, z: 17.9208 },
      size: { w: 0.748, d: 0.637, h: 0.589 },
      color: 0x7a6544,
      interactable: true,
      lootObjectId: "raid_subway_district:cache-5",
      modelUrl: "/models/objects/obj_toolbox.glb",
      rotationY: 1.212,
    },
    {
      id: "loot-6",
      kind: "loot",
      label: "Supply Crate",
      position: { x: 10.016, z: -11.361 },
      size: { w: 1.134, d: 1.134, h: 0.94 },
      color: 0x7a6544,
      interactable: true,
      lootObjectId: "raid_subway_district:cache-6",
      modelUrl: "/models/objects/obj_crate-wood.glb",
      rotationY: 1.972,
    },
    {
      id: "loot-7",
      kind: "loot",
      label: "Stacked Crates",
      position: { x: -18.7148, z: -1.6109 },
      size: { w: 1.561, d: 1.486, h: 0.858 },
      color: 0x7a6544,
      interactable: true,
      lootObjectId: "raid_subway_district:cache-7",
      modelUrl: "/models/objects/obj_crates.glb",
      rotationY: 2,
    },
    {
      id: "loot-8",
      kind: "loot",
      label: "Ammo Case",
      position: { x: 23.374, z: -0.958 },
      size: { w: 1.155, d: 1.053, h: 0.689 },
      color: 0x7a6544,
      interactable: true,
      lootObjectId: "raid_subway_district:cache-8",
      modelUrl: "/models/objects/obj_crates-2.glb",
      rotationY: 6.209,
    },
    {
      id: "loot-9",
      kind: "loot",
      label: "Dumped Barrel",
      position: { x: 20.829, z: 18.023 },
      size: { w: 1.035, d: 1.035, h: 1.389 },
      color: 0x7a6544,
      interactable: true,
      lootObjectId: "raid_subway_district:cache-9",
      modelUrl: "/models/objects/obj_barrel.glb",
      rotationY: 3.459,
    },
    {
      id: "loot-10",
      kind: "loot",
      label: "Toolbox",
      position: { x: -22.775, z: 16.497 },
      size: { w: 0.67, d: 0.57, h: 0.528 },
      color: 0x7a6544,
      interactable: true,
      lootObjectId: "raid_subway_district:cache-10",
      modelUrl: "/models/objects/obj_toolbox.glb",
      rotationY: 2.376,
    },
    {
      id: "subway_district-junk-1",
      kind: "prop",
      label: "Jersey Barrier",
      position: { x: 13.804, z: 23.279 },
      size: { w: 0.907, d: 2.348, h: 0.891 },
      color: 0x8a8578,
      interactable: false,
      modelUrl: "/models/objects/obj_jersey-barrier.glb",
      rotationY: 2.961,
    },
    {
      id: "subway_district-junk-2",
      kind: "prop",
      label: "Tyre Pile",
      position: { x: 21.132, z: -3.861 },
      size: { w: 1.98, d: 1.788, h: 0.838 },
      color: 0x2a2724,
      interactable: false,
      modelUrl: "/models/objects/obj_tyre-pile.glb",
      rotationY: 6.163,
    },
    {
      id: "subway_district-junk-3",
      kind: "prop",
      label: "Crates",
      position: { x: -14.014, z: -1.668 },
      size: { w: 1.217, d: 1.159, h: 0.669 },
      color: 0x7a6544,
      interactable: false,
      modelUrl: "/models/objects/obj_crates.glb",
      rotationY: 3.732,
    },
    {
      id: "subway_district-junk-4",
      kind: "prop",
      label: "Cable Spool",
      position: { x: -1.218, z: 13.106 },
      size: { w: 0.601, d: 0.506, h: 0.438 },
      color: 0x5a4d38,
      interactable: false,
      modelUrl: "/models/objects/obj_rope-coil.glb",
      rotationY: 2.9,
      noClip: true,
    },
    {
      id: "subway_district-junk-5",
      kind: "prop",
      label: "Dumpster",
      position: { x: -21.399, z: -1.127 },
      size: { w: 1.762, d: 1.4, h: 1.261 },
      color: 0x3f5546,
      interactable: false,
      modelUrl: "/models/objects/obj_dumpster.glb",
      rotationY: 5.458,
    },
    {
      id: "subway_district-junk-6",
      kind: "prop",
      label: "Barrel",
      position: { x: 1.818, z: -9.694 },
      size: { w: 0.774, d: 0.774, h: 1.039 },
      color: 0x6b5a3c,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel.glb",
      rotationY: 2.301,
    },
    {
      id: "subway_district-junk-7",
      kind: "prop",
      label: "Sandbags",
      position: { x: 16.211, z: 23.599 },
      size: { w: 1.976, d: 0.287, h: 0.269 },
      color: 0x7a6d4e,
      interactable: false,
      modelUrl: "/models/objects/obj_sandbag-wall.glb",
      rotationY: 2.352,
    },
    {
      id: "subway_district-junk-8",
      kind: "prop",
      label: "Barrel",
      position: { x: -18.452, z: 22.265 },
      size: { w: 0.631, d: 0.631, h: 0.847 },
      color: 0x6b5a3c,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel.glb",
      rotationY: 6.135,
    },
    {
      id: "subway_district-junk-9",
      kind: "prop",
      label: "Sandbags",
      position: { x: 9.308, z: -0.806 },
      size: { w: 1.612, d: 0.234, h: 0.22 },
      color: 0x7a6d4e,
      interactable: false,
      modelUrl: "/models/objects/obj_sandbag-wall.glb",
      rotationY: 1.408,
    },
    {
      id: "subway_district-junk-10",
      kind: "prop",
      label: "Sandbags",
      position: { x: 12.096, z: 21.099 },
      size: { w: 1.921, d: 0.279, h: 0.262 },
      color: 0x7a6d4e,
      interactable: false,
      modelUrl: "/models/objects/obj_sandbag-wall.glb",
      rotationY: 1.301,
    },
    {
      id: "subway_district-junk-11",
      kind: "prop",
      label: "Dumpster",
      position: { x: -24.12, z: -11.224 },
      size: { w: 2.216, d: 1.761, h: 1.586 },
      color: 0x3f5546,
      interactable: false,
      modelUrl: "/models/objects/obj_dumpster.glb",
      rotationY: 5.082,
    },
    {
      id: "subway_district-junk-12",
      kind: "prop",
      label: "Crates",
      position: { x: -24.155, z: 5.21 },
      size: { w: 1.398, d: 1.331, h: 0.768 },
      color: 0x7a6544,
      interactable: false,
      modelUrl: "/models/objects/obj_crates.glb",
      rotationY: 4.988,
    },
    {
      id: "subway_district-junk-13",
      kind: "prop",
      label: "Crates",
      position: { x: 15.057, z: -21.962 },
      size: { w: 1.6, d: 1.523, h: 0.879 },
      color: 0x7a6544,
      interactable: false,
      modelUrl: "/models/objects/obj_crates.glb",
      rotationY: 1.227,
    },
    {
      id: "subway_district-junk-14",
      kind: "prop",
      label: "Crates",
      position: { x: -4.737, z: -25.315 },
      size: { w: 1.61, d: 1.533, h: 0.885 },
      color: 0x7a6544,
      interactable: false,
      modelUrl: "/models/objects/obj_crates.glb",
      rotationY: 4.04,
    },
    {
      id: "subway_district-junk-15",
      kind: "prop",
      label: "Sandbags",
      position: { x: 4.351, z: -18.744 },
      size: { w: 1.627, d: 0.236, h: 0.222 },
      color: 0x7a6d4e,
      interactable: false,
      modelUrl: "/models/objects/obj_sandbag-wall.glb",
      rotationY: 4.767,
    },
    {
      id: "subway_district-junk-16",
      kind: "prop",
      label: "Tyre Pile",
      position: { x: 6.844, z: -25.496 },
      size: { w: 1.925, d: 1.739, h: 0.815 },
      color: 0x2a2724,
      interactable: false,
      modelUrl: "/models/objects/obj_tyre-pile.glb",
      rotationY: 0.508,
    },
    {
      id: "subway_district-junk-17",
      kind: "prop",
      label: "Barrel",
      position: { x: 6.041, z: 11.275 },
      size: { w: 0.746, d: 0.746, h: 1.002 },
      color: 0x6b5a3c,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel.glb",
      rotationY: 3.331,
    },
    {
      id: "subway_district-junk-18",
      kind: "prop",
      label: "Half Barrel",
      position: { x: 7.986, z: 17.529 },
      size: { w: 0.591, d: 0.563, h: 0.539 },
      color: 0x6b5a3c,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel-half.glb",
      rotationY: 2.697,
    },
    {
      id: "subway_district-junk-19",
      kind: "prop",
      label: "Scrap Pile",
      position: { x: 14.827, z: 9.606 },
      size: { w: 1.458, d: 1.253, h: 0.433 },
      color: 0x5d5a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_tarp-roll.glb",
      rotationY: 0.952,
      noClip: true,
      positionY: -0.05,
    },
    {
      id: "subway_district-junk-20",
      kind: "prop",
      label: "Barrel",
      position: { x: 11.423, z: 16.894 },
      size: { w: 0.758, d: 0.758, h: 1.017 },
      color: 0x6b5a3c,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel.glb",
      rotationY: 2.886,
    },
    {
      id: "subway_district-junk-21",
      kind: "prop",
      label: "Sandbags",
      position: { x: 2.182, z: -12.922 },
      size: { w: 1.994, d: 0.289, h: 0.272 },
      color: 0x7a6d4e,
      interactable: false,
      modelUrl: "/models/objects/obj_sandbag-wall.glb",
      rotationY: 1.532,
    },
    {
      id: "subway_district-junk-22",
      kind: "prop",
      label: "Barrel",
      position: { x: -30.002, z: -2.596 },
      size: { w: 0.781, d: 0.781, h: 1.048 },
      color: 0x6b5a3c,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel.glb",
      rotationY: 0.364,
    },
    {
      id: "subway_district-junk-23",
      kind: "prop",
      label: "Scrap Pile",
      position: { x: 2.494, z: 8.491 },
      size: { w: 1.421, d: 1.222, h: 0.422 },
      color: 0x5d5a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_tarp-roll.glb",
      rotationY: 2.364,
      noClip: true,
      positionY: -0.05,
    },
    {
      id: "subway_district-junk-24",
      kind: "prop",
      label: "Tyre Pile",
      position: { x: 23.45, z: -8.786 },
      size: { w: 2.364, d: 2.135, h: 1.001 },
      color: 0x2a2724,
      interactable: false,
      modelUrl: "/models/objects/obj_tyre-pile.glb",
      rotationY: 2.165,
    },
    {
      id: "subway_district-junk-25",
      kind: "prop",
      label: "Cable Spool",
      position: { x: 3.404, z: -20.002 },
      size: { w: 0.489, d: 0.412, h: 0.357 },
      color: 0x5a4d38,
      interactable: false,
      modelUrl: "/models/objects/obj_rope-coil.glb",
      rotationY: 1.973,
      noClip: true,
    },
    {
      id: "subway_district-junk-26",
      kind: "prop",
      label: "Pallet Stack",
      position: { x: 16.433, z: 7.071 },
      size: { w: 1.709, d: 0.977, h: 0.864 },
      color: 0x6f5c3e,
      interactable: false,
      modelUrl: "/models/objects/obj_blocks-stack.glb",
      rotationY: 1.505,
    },
    {
      id: "subway_district-junk-27",
      kind: "prop",
      label: "Tyre Pile",
      position: { x: 23.789, z: 1.742 },
      size: { w: 1.86, d: 1.68, h: 0.788 },
      color: 0x2a2724,
      interactable: false,
      modelUrl: "/models/objects/obj_tyre-pile.glb",
      rotationY: 3.403,
    },
    {
      id: "subway_district-junk-28",
      kind: "prop",
      label: "Crates",
      position: { x: 12.635, z: -19.258 },
      size: { w: 1.459, d: 1.39, h: 0.802 },
      color: 0x7a6544,
      interactable: false,
      modelUrl: "/models/objects/obj_crates.glb",
      rotationY: 5.839,
    },
    {
      id: "subway_district-junk-29",
      kind: "prop",
      label: "Tyre Pile",
      position: { x: -25.308, z: -18.76 },
      size: { w: 2.253, d: 2.035, h: 0.954 },
      color: 0x2a2724,
      interactable: false,
      modelUrl: "/models/objects/obj_tyre-pile.glb",
      rotationY: 4.54,
    },
    {
      id: "subway_district-junk-30",
      kind: "prop",
      label: "Scrap Pile",
      position: { x: 16.088, z: 5.295 },
      size: { w: 1.459, d: 1.254, h: 0.433 },
      color: 0x5d5a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_tarp-roll.glb",
      rotationY: 2.722,
      noClip: true,
      positionY: -0.05,
    },
    {
      id: "subway_district-junk-31",
      kind: "prop",
      label: "Crates",
      position: { x: -0.362, z: -8.496 },
      size: { w: 1.163, d: 1.108, h: 0.639 },
      color: 0x7a6544,
      interactable: false,
      modelUrl: "/models/objects/obj_crates.glb",
      rotationY: 3.609,
    },
    {
      id: "subway_district-junk-32",
      kind: "prop",
      label: "Pallet Stack",
      position: { x: 7.498, z: -1.36 },
      size: { w: 1.377, d: 0.788, h: 0.697 },
      color: 0x6f5c3e,
      interactable: false,
      modelUrl: "/models/objects/obj_blocks-stack.glb",
      rotationY: 5.097,
    },
    {
      id: "subway_district-junk-34",
      kind: "prop",
      label: "Half Barrel",
      position: { x: -32.448, z: 3.593 },
      size: { w: 0.513, d: 0.489, h: 0.468 },
      color: 0x6b5a3c,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel-half.glb",
      rotationY: 1.44,
    },
    {
      id: "subway_district-junk-35",
      kind: "prop",
      label: "Pallet Stack",
      position: { x: -25.214, z: 11.832 },
      size: { w: 1.44, d: 0.823, h: 0.728 },
      color: 0x6f5c3e,
      interactable: false,
      modelUrl: "/models/objects/obj_blocks-stack.glb",
      rotationY: 5.031,
    },
    {
      id: "subway_district-junk-36",
      kind: "prop",
      label: "Pallet Stack",
      position: { x: 20.643, z: -6.53 },
      size: { w: 1.59, d: 0.909, h: 0.804 },
      color: 0x6f5c3e,
      interactable: false,
      modelUrl: "/models/objects/obj_blocks-stack.glb",
      rotationY: 5.941,
    },
    {
      id: "subway_district-junk-37",
      kind: "prop",
      label: "Barrel",
      position: { x: 22.699, z: 6.795 },
      size: { w: 0.683, d: 0.683, h: 0.916 },
      color: 0x6b5a3c,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel.glb",
      rotationY: 2.919,
    },
    {
      id: "subway_district-junk-38",
      kind: "prop",
      label: "Pallet Stack",
      position: { x: -26.015, z: -0.779 },
      size: { w: 1.503, d: 0.859, h: 0.76 },
      color: 0x6f5c3e,
      interactable: false,
      modelUrl: "/models/objects/obj_blocks-stack.glb",
      rotationY: 2.777,
    },
    {
      id: "subway_district-junk-39",
      kind: "prop",
      label: "Barrel",
      position: { x: 5.909, z: -12.471 },
      size: { w: 0.637, d: 0.637, h: 0.855 },
      color: 0x6b5a3c,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel.glb",
      rotationY: 4.284,
    },
    {
      id: "subway_district-junk-40",
      kind: "prop",
      label: "Half Barrel",
      position: { x: 25.519, z: 12.06 },
      size: { w: 0.628, d: 0.599, h: 0.573 },
      color: 0x6b5a3c,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel-half.glb",
      rotationY: 0.785,
    },
    {
      id: "subway_district-junk-41",
      kind: "prop",
      label: "Pallet Stack",
      position: { x: 8.303, z: 19.873 },
      size: { w: 1.3, d: 0.743, h: 0.657 },
      color: 0x6f5c3e,
      interactable: false,
      modelUrl: "/models/objects/obj_blocks-stack.glb",
      rotationY: 0.929,
    },
    {
      id: "subway_district-junk-42",
      kind: "prop",
      label: "Crates",
      position: { x: 16.176, z: 27.643 },
      size: { w: 1.223, d: 1.164, h: 0.672 },
      color: 0x7a6544,
      interactable: false,
      modelUrl: "/models/objects/obj_crates.glb",
      rotationY: 2.404,
    },
    {
      id: "subway_district-junk-43",
      kind: "prop",
      label: "Scrap Pile",
      position: { x: 29.081, z: -14.105 },
      size: { w: 1.176, d: 1.011, h: 0.349 },
      color: 0x5d5a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_tarp-roll.glb",
      rotationY: 5.608,
      noClip: true,
      positionY: -0.05,
    },
    {
      id: "subway_district-junk-44",
      kind: "prop",
      label: "Pallet Stack",
      position: { x: 8.128, z: 22.426 },
      size: { w: 1.84, d: 1.052, h: 0.93 },
      color: 0x6f5c3e,
      interactable: false,
      modelUrl: "/models/objects/obj_blocks-stack.glb",
      rotationY: 2.224,
    },
    {
      id: "subway_district-junk-45",
      kind: "prop",
      label: "Half Barrel",
      position: { x: 19.526, z: -26.573 },
      size: { w: 0.458, d: 0.437, h: 0.418 },
      color: 0x6b5a3c,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel-half.glb",
      rotationY: 0.11,
    },
    {
      id: "subway_district-junk-46",
      kind: "prop",
      label: "Jersey Barrier",
      position: { x: 20.329, z: 5.61 },
      size: { w: 1.042, d: 2.697, h: 1.024 },
      color: 0x8a8578,
      interactable: false,
      modelUrl: "/models/objects/obj_jersey-barrier.glb",
      rotationY: 2.561,
    },
    {
      id: "subway_district-junk-47",
      kind: "prop",
      label: "Half Barrel",
      position: { x: -31.814, z: 6.299 },
      size: { w: 0.553, d: 0.528, h: 0.505 },
      color: 0x6b5a3c,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel-half.glb",
      rotationY: 4.747,
    },
    {
      id: "subway_district-junk-48",
      kind: "prop",
      label: "Crates",
      position: { x: -8.02, z: -1.083 },
      size: { w: 1.314, d: 1.251, h: 0.722 },
      color: 0x7a6544,
      interactable: false,
      modelUrl: "/models/objects/obj_crates.glb",
      rotationY: 0.067,
    },
    {
      id: "subway_district-junk-49",
      kind: "prop",
      label: "Barrel",
      position: { x: -7.538, z: -27.179 },
      size: { w: 0.835, d: 0.835, h: 1.121 },
      color: 0x6b5a3c,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel.glb",
      rotationY: 0.731,
    },
    {
      id: "subway_district-junk-50",
      kind: "prop",
      label: "Dumpster",
      position: { x: 26.676, z: -10.704 },
      size: { w: 2.235, d: 1.777, h: 1.6 },
      color: 0x3f5546,
      interactable: false,
      modelUrl: "/models/objects/obj_dumpster.glb",
      rotationY: 5.183,
    },
    {
      id: "subway_district-junk-51",
      kind: "prop",
      label: "Pallet Stack",
      position: { x: -27.807, z: 10.369 },
      size: { w: 1.858, d: 1.062, h: 0.939 },
      color: 0x6f5c3e,
      interactable: false,
      modelUrl: "/models/objects/obj_blocks-stack.glb",
      rotationY: 0.244,
    },
    {
      id: "subway_district-junk-53",
      kind: "prop",
      label: "Barrel",
      position: { x: 0.161, z: -16.884 },
      size: { w: 0.783, d: 0.783, h: 1.051 },
      color: 0x6b5a3c,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel.glb",
      rotationY: 3.952,
    },
    {
      id: "subway_district-junk-54",
      kind: "prop",
      label: "Scrap Pile",
      position: { x: -0.251, z: -10.26 },
      size: { w: 1.203, d: 1.034, h: 0.357 },
      color: 0x5d5a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_tarp-roll.glb",
      rotationY: 5.397,
      noClip: true,
      positionY: -0.05,
    },
    {
      id: "subway_district-junk-55",
      kind: "prop",
      label: "Dumpster",
      position: { x: -7.906, z: 13.879 },
      size: { w: 1.907, d: 1.515, h: 1.365 },
      color: 0x3f5546,
      interactable: false,
      modelUrl: "/models/objects/obj_dumpster.glb",
      rotationY: 1.218,
    },
    {
      id: "subway_district-junk-56",
      kind: "prop",
      label: "Cable Spool",
      position: { x: -10.295, z: 30.828 },
      size: { w: 0.542, d: 0.457, h: 0.395 },
      color: 0x5a4d38,
      interactable: false,
      modelUrl: "/models/objects/obj_rope-coil.glb",
      rotationY: 1.079,
      noClip: true,
    },
    {
      id: "subway_district-junk-57",
      kind: "prop",
      label: "Crates",
      position: { x: 28.652, z: -6.684 },
      size: { w: 1.159, d: 1.104, h: 0.637 },
      color: 0x7a6544,
      interactable: false,
      modelUrl: "/models/objects/obj_crates.glb",
      rotationY: 0.627,
    },
    {
      id: "subway_district-junk-58",
      kind: "prop",
      label: "Cable Spool",
      position: { x: 9.055, z: -23.879 },
      size: { w: 0.584, d: 0.493, h: 0.426 },
      color: 0x5a4d38,
      interactable: false,
      modelUrl: "/models/objects/obj_rope-coil.glb",
      rotationY: 5.205,
      noClip: true,
    },
    {
      id: "subway_district-junk-59",
      kind: "prop",
      label: "Pallet Stack",
      position: { x: -25.526, z: 6.528 },
      size: { w: 1.768, d: 1.011, h: 0.894 },
      color: 0x6f5c3e,
      interactable: false,
      modelUrl: "/models/objects/obj_blocks-stack.glb",
      rotationY: 4.955,
    },
    {
      id: "subway_district-junk-60",
      kind: "prop",
      label: "Pallet Stack",
      position: { x: -10.879, z: -26.008 },
      size: { w: 1.861, d: 1.064, h: 0.941 },
      color: 0x6f5c3e,
      interactable: false,
      modelUrl: "/models/objects/obj_blocks-stack.glb",
      rotationY: 0.573,
    },
    {
      id: "subway_district-junk-61",
      kind: "prop",
      label: "Crates",
      position: { x: 18.937, z: 25.853 },
      size: { w: 1.458, d: 1.388, h: 0.801 },
      color: 0x7a6544,
      interactable: false,
      modelUrl: "/models/objects/obj_crates.glb",
      rotationY: 4.373,
    },
    {
      id: "subway_district-junk-62",
      kind: "prop",
      label: "Crates",
      position: { x: -10.282, z: 13.709 },
      size: { w: 1.53, d: 1.457, h: 0.841 },
      color: 0x7a6544,
      interactable: false,
      modelUrl: "/models/objects/obj_crates.glb",
      rotationY: 5.639,
    },
    {
      id: "subway_district-junk-63",
      kind: "prop",
      label: "Sandbags",
      position: { x: -1.481, z: 24.274 },
      size: { w: 2.037, d: 0.296, h: 0.278 },
      color: 0x7a6d4e,
      interactable: false,
      modelUrl: "/models/objects/obj_sandbag-wall.glb",
      rotationY: 3.58,
    },
    {
      id: "subway_district-junk-64",
      kind: "prop",
      label: "Barrel",
      position: { x: 22.928, z: 0.378 },
      size: { w: 0.744, d: 0.744, h: 0.999 },
      color: 0x6b5a3c,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel.glb",
      rotationY: 2.098,
    },
    {
      id: "subway_district-junk-65",
      kind: "prop",
      label: "Barrel",
      position: { x: -29.541, z: 1.962 },
      size: { w: 0.641, d: 0.641, h: 0.86 },
      color: 0x6b5a3c,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel.glb",
      rotationY: 3.39,
    },
    {
      id: "subway_district-junk-66",
      kind: "prop",
      label: "Scrap Pile",
      position: { x: -13.687, z: 25.318 },
      size: { w: 1.264, d: 1.087, h: 0.375 },
      color: 0x5d5a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_tarp-roll.glb",
      rotationY: 1.068,
      noClip: true,
      positionY: -0.05,
    },
    {
      id: "subway_district-junk-68",
      kind: "prop",
      label: "Barrel",
      position: { x: -30.004, z: -0.249 },
      size: { w: 0.675, d: 0.675, h: 0.906 },
      color: 0x6b5a3c,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel.glb",
      rotationY: 4.006,
    },
    {
      id: "subway_district-junk-70",
      kind: "prop",
      label: "Half Barrel",
      position: { x: 6.736, z: -15.09 },
      size: { w: 0.64, d: 0.611, h: 0.584 },
      color: 0x6b5a3c,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel-half.glb",
      rotationY: 3.947,
    },
    {
      id: "subway_district-junk-71",
      kind: "prop",
      label: "Barrel",
      position: { x: 15.883, z: -23.266 },
      size: { w: 0.643, d: 0.643, h: 0.864 },
      color: 0x6b5a3c,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel.glb",
      rotationY: 0.672,
    },
    {
      id: "subway_district-junk-72",
      kind: "prop",
      label: "Sandbags",
      position: { x: -25.614, z: -4.873 },
      size: { w: 1.758, d: 0.255, h: 0.239 },
      color: 0x7a6d4e,
      interactable: false,
      modelUrl: "/models/objects/obj_sandbag-wall.glb",
      rotationY: 5.045,
    },
    {
      id: "subway_district-junk-73",
      kind: "prop",
      label: "Cable Spool",
      position: { x: -9.532, z: -24.995 },
      size: { w: 0.543, d: 0.457, h: 0.396 },
      color: 0x5a4d38,
      interactable: false,
      modelUrl: "/models/objects/obj_rope-coil.glb",
      rotationY: 0.379,
      noClip: true,
    },
    {
      id: "subway_district-junk-74",
      kind: "prop",
      label: "Pallet Stack",
      position: { x: -28.446, z: 16.273 },
      size: { w: 1.773, d: 1.014, h: 0.896 },
      color: 0x6f5c3e,
      interactable: false,
      modelUrl: "/models/objects/obj_blocks-stack.glb",
      rotationY: 2.986,
    },
    {
      id: "subway_district-junk-75",
      kind: "prop",
      label: "Barrel",
      position: { x: 11.241, z: 26.942 },
      size: { w: 0.808, d: 0.808, h: 1.084 },
      color: 0x6b5a3c,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel.glb",
      rotationY: 4.397,
    },
    {
      id: "subway_district-junk-76",
      kind: "prop",
      label: "Cable Spool",
      position: { x: -19.162, z: -14.184 },
      size: { w: 0.592, d: 0.499, h: 0.432 },
      color: 0x5a4d38,
      interactable: false,
      modelUrl: "/models/objects/obj_rope-coil.glb",
      rotationY: 3.607,
      noClip: true,
    },
    {
      id: "subway_district-junk-77",
      kind: "prop",
      label: "Half Barrel",
      position: { x: 3.009, z: -29.112 },
      size: { w: 0.506, d: 0.482, h: 0.462 },
      color: 0x6b5a3c,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel-half.glb",
      rotationY: 1.55,
    },
    {
      id: "subway_district-junk-78",
      kind: "prop",
      label: "Scrap Pile",
      position: { x: 9.774, z: 19.58 },
      size: { w: 1.586, d: 1.364, h: 0.471 },
      color: 0x5d5a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_tarp-roll.glb",
      rotationY: 4.536,
      noClip: true,
      positionY: -0.05,
    },
    {
      id: "subway_district-junk-79",
      kind: "prop",
      label: "Cable Spool",
      position: { x: -1.729, z: -9.016 },
      size: { w: 0.477, d: 0.402, h: 0.348 },
      color: 0x5a4d38,
      interactable: false,
      modelUrl: "/models/objects/obj_rope-coil.glb",
      rotationY: 6.15,
      noClip: true,
    },
    {
      id: "subway_district-junk-80",
      kind: "prop",
      label: "Half Barrel",
      position: { x: -28.165, z: 3.494 },
      size: { w: 0.61, d: 0.582, h: 0.556 },
      color: 0x6b5a3c,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel-half.glb",
      rotationY: 4.897,
    },
    {
      id: "subway_district-junk-81",
      kind: "prop",
      label: "Cable Spool",
      position: { x: -23.778, z: -6.729 },
      size: { w: 0.545, d: 0.459, h: 0.397 },
      color: 0x5a4d38,
      interactable: false,
      modelUrl: "/models/objects/obj_rope-coil.glb",
      rotationY: 0.806,
      noClip: true,
    },
    {
      id: "subway_district-junk-82",
      kind: "prop",
      label: "Barrel",
      position: { x: -0.158, z: 16.006 },
      size: { w: 0.722, d: 0.722, h: 0.969 },
      color: 0x6b5a3c,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel.glb",
      rotationY: 2.979,
    },
    {
      id: "subway_district-junk-83",
      kind: "prop",
      label: "Tyre Pile",
      position: { x: -22.459, z: -4.534 },
      size: { w: 2.463, d: 2.224, h: 1.043 },
      color: 0x2a2724,
      interactable: false,
      modelUrl: "/models/objects/obj_tyre-pile.glb",
      rotationY: 4.458,
    },
    {
      id: "subway_district-junk-84",
      kind: "prop",
      label: "Scrap Pile",
      position: { x: -1.26, z: -31.204 },
      size: { w: 1.48, d: 1.273, h: 0.439 },
      color: 0x5d5a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_tarp-roll.glb",
      rotationY: 4.051,
      noClip: true,
      positionY: -0.05,
    },
    {
      id: "subway_district-junk-85",
      kind: "prop",
      label: "Half Barrel",
      position: { x: -24.29, z: 2.605 },
      size: { w: 0.523, d: 0.498, h: 0.477 },
      color: 0x6b5a3c,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel-half.glb",
      rotationY: 4.674,
    },
    {
      id: "subway_district-junk-86",
      kind: "prop",
      label: "Half Barrel",
      position: { x: 9.733, z: -2.894 },
      size: { w: 0.553, d: 0.527, h: 0.505 },
      color: 0x6b5a3c,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel-half.glb",
      rotationY: 2.925,
    },
    {
      id: "subway_district-junk-87",
      kind: "prop",
      label: "Pallet Stack",
      position: { x: 18.225, z: 8.555 },
      size: { w: 1.307, d: 0.747, h: 0.661 },
      color: 0x6f5c3e,
      interactable: false,
      modelUrl: "/models/objects/obj_blocks-stack.glb",
      rotationY: 4.327,
    },
    {
      id: "subway_district-junk-88",
      kind: "prop",
      label: "Tyre Pile",
      position: { x: -19.928, z: -9.934 },
      size: { w: 2.044, d: 1.846, h: 0.865 },
      color: 0x2a2724,
      interactable: false,
      modelUrl: "/models/objects/obj_tyre-pile.glb",
      rotationY: 4.906,
    },
    {
      id: "subway_district-junk-89",
      kind: "prop",
      label: "Tyre Pile",
      position: { x: -13.897, z: 19.797 },
      size: { w: 2.377, d: 2.147, h: 1.007 },
      color: 0x2a2724,
      interactable: false,
      modelUrl: "/models/objects/obj_tyre-pile.glb",
      rotationY: 0.225,
    },
    {
      id: "subway_district-junk-90",
      kind: "prop",
      label: "Tyre Pile",
      position: { x: -28.097, z: -9.534 },
      size: { w: 2.013, d: 1.818, h: 0.852 },
      color: 0x2a2724,
      interactable: false,
      modelUrl: "/models/objects/obj_tyre-pile.glb",
      rotationY: 3.748,
    },
    {
      id: "subway_district-junk-91",
      kind: "prop",
      label: "Crates",
      position: { x: 25.801, z: -3.819 },
      size: { w: 1.322, d: 1.259, h: 0.727 },
      color: 0x7a6544,
      interactable: false,
      modelUrl: "/models/objects/obj_crates.glb",
      rotationY: 4.763,
    },
    {
      id: "subway_district-junk-92",
      kind: "prop",
      label: "Pallet Stack",
      position: { x: 14.796, z: 28.684 },
      size: { w: 1.761, d: 1.007, h: 0.89 },
      color: 0x6f5c3e,
      interactable: false,
      modelUrl: "/models/objects/obj_blocks-stack.glb",
      rotationY: 0.168,
    },
    {
      id: "subway_district-junk-93",
      kind: "prop",
      label: "Crates",
      position: { x: 1.236, z: -30.444 },
      size: { w: 1.32, d: 1.257, h: 0.726 },
      color: 0x7a6544,
      interactable: false,
      modelUrl: "/models/objects/obj_crates.glb",
      rotationY: 4.321,
    },
    {
      id: "subway_district-junk-94",
      kind: "prop",
      label: "Pallet Stack",
      position: { x: 7.938, z: -19.735 },
      size: { w: 1.767, d: 1.01, h: 0.893 },
      color: 0x6f5c3e,
      interactable: false,
      modelUrl: "/models/objects/obj_blocks-stack.glb",
      rotationY: 4.217,
    },
    {
      id: "subway_district-junk-95",
      kind: "prop",
      label: "Pallet Stack",
      position: { x: 8.561, z: -27.283 },
      size: { w: 1.602, d: 0.916, h: 0.81 },
      color: 0x6f5c3e,
      interactable: false,
      modelUrl: "/models/objects/obj_blocks-stack.glb",
      rotationY: 1.966,
    },
    {
      id: "subway_district-junk-96",
      kind: "prop",
      label: "Half Barrel",
      position: { x: 8.236, z: -22.32 },
      size: { w: 0.542, d: 0.517, h: 0.494 },
      color: 0x6b5a3c,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel-half.glb",
      rotationY: 1.268,
    },
    {
      id: "subway_district-junk-97",
      kind: "prop",
      label: "Pallet Stack",
      position: { x: 17.74, z: 2.056 },
      size: { w: 1.538, d: 0.879, h: 0.778 },
      color: 0x6f5c3e,
      interactable: false,
      modelUrl: "/models/objects/obj_blocks-stack.glb",
      rotationY: 3.014,
    },
    {
      id: "subway_district-junk-98",
      kind: "prop",
      label: "Cable Spool",
      position: { x: 27.12, z: 13.791 },
      size: { w: 0.454, d: 0.382, h: 0.331 },
      color: 0x5a4d38,
      interactable: false,
      modelUrl: "/models/objects/obj_rope-coil.glb",
      rotationY: 3.705,
      noClip: true,
    },
    {
      id: "subway_district-junk-99",
      kind: "prop",
      label: "Half Barrel",
      position: { x: -25.856, z: 3.512 },
      size: { w: 0.541, d: 0.516, h: 0.494 },
      color: 0x6b5a3c,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel-half.glb",
      rotationY: 5.437,
    },
    {
      id: "subway_district-junk-100",
      kind: "prop",
      label: "Scrap Pile",
      position: { x: -30.81, z: -8.066 },
      size: { w: 1.453, d: 1.25, h: 0.431 },
      color: 0x5d5a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_tarp-roll.glb",
      rotationY: 5.876,
      noClip: true,
      positionY: -0.05,
    },
    {
      id: "subway_district-junk-101",
      kind: "prop",
      label: "Tyre Pile",
      position: { x: -0.542, z: -20.162 },
      size: { w: 1.959, d: 1.769, h: 0.829 },
      color: 0x2a2724,
      interactable: false,
      modelUrl: "/models/objects/obj_tyre-pile.glb",
      rotationY: 4.111,
    },
    {
      id: "subway_district-junk-102",
      kind: "prop",
      label: "Pallet Stack",
      position: { x: 2.784, z: -8.939 },
      size: { w: 1.541, d: 0.881, h: 0.779 },
      color: 0x6f5c3e,
      interactable: false,
      modelUrl: "/models/objects/obj_blocks-stack.glb",
      rotationY: 3.749,
    },
    {
      id: "subway_district-junk-103",
      kind: "prop",
      label: "Pallet Stack",
      position: { x: -27.89, z: -13.001 },
      size: { w: 1.669, d: 0.954, h: 0.844 },
      color: 0x6f5c3e,
      interactable: false,
      modelUrl: "/models/objects/obj_blocks-stack.glb",
      rotationY: 4.462,
    },
    {
      id: "subway_district-junk-104",
      kind: "prop",
      label: "Crates",
      position: { x: 13.741, z: 26.842 },
      size: { w: 1.434, d: 1.366, h: 0.788 },
      color: 0x7a6544,
      interactable: false,
      modelUrl: "/models/objects/obj_crates.glb",
      rotationY: 1.125,
    },
    {
      id: "subway_district-junk-105",
      kind: "prop",
      label: "Tyre Pile",
      position: { x: 11.547, z: 3.208 },
      size: { w: 2.148, d: 1.94, h: 0.91 },
      color: 0x2a2724,
      interactable: false,
      modelUrl: "/models/objects/obj_tyre-pile.glb",
      rotationY: 0.787,
    },
    {
      id: "subway_district-junk-106",
      kind: "prop",
      label: "Sandbags",
      position: { x: 26.805, z: -15.932 },
      size: { w: 1.909, d: 0.277, h: 0.26 },
      color: 0x7a6d4e,
      interactable: false,
      modelUrl: "/models/objects/obj_sandbag-wall.glb",
      rotationY: 0.463,
    },
    {
      id: "subway_district-junk-107",
      kind: "prop",
      label: "Pallet Stack",
      position: { x: -6.801, z: 19.005 },
      size: { w: 1.37, d: 0.783, h: 0.693 },
      color: 0x6f5c3e,
      interactable: false,
      modelUrl: "/models/objects/obj_blocks-stack.glb",
      rotationY: 2.071,
    },
    {
      id: "subway_district-junk-108",
      kind: "prop",
      label: "Dumpster",
      position: { x: 6.484, z: 27.461 },
      size: { w: 1.921, d: 1.527, h: 1.375 },
      color: 0x3f5546,
      interactable: false,
      modelUrl: "/models/objects/obj_dumpster.glb",
      rotationY: 1.466,
    },
    {
      id: "subway_district-junk-109",
      kind: "prop",
      label: "Barrel",
      position: { x: -23.697, z: 11.271 },
      size: { w: 0.765, d: 0.765, h: 1.027 },
      color: 0x6b5a3c,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel.glb",
      rotationY: 2.902,
    },
    {
      id: "subway_district-junk-110",
      kind: "prop",
      label: "Cable Spool",
      position: { x: 28.905, z: 8.076 },
      size: { w: 0.592, d: 0.499, h: 0.432 },
      color: 0x5a4d38,
      interactable: false,
      modelUrl: "/models/objects/obj_rope-coil.glb",
      rotationY: 5.784,
      noClip: true,
    },
    {
      id: "subway_district-junk-112",
      kind: "prop",
      label: "Sandbags",
      position: { x: 18.776, z: -7.914 },
      size: { w: 1.521, d: 0.221, h: 0.207 },
      color: 0x7a6d4e,
      interactable: false,
      modelUrl: "/models/objects/obj_sandbag-wall.glb",
      rotationY: 0.358,
    },
    {
      id: "subway_district-junk-113",
      kind: "prop",
      label: "Scrap Pile",
      position: { x: -24.659, z: 10.081 },
      size: { w: 1.276, d: 1.097, h: 0.379 },
      color: 0x5d5a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_tarp-roll.glb",
      rotationY: 0.419,
      noClip: true,
      positionY: -0.05,
    },
    {
      id: "subway_district-junk-114",
      kind: "prop",
      label: "Barrel",
      position: { x: -19.45, z: -25.519 },
      size: { w: 0.637, d: 0.637, h: 0.855 },
      color: 0x6b5a3c,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel.glb",
      rotationY: 0.902,
    },
    {
      id: "subway_district-junk-115",
      kind: "prop",
      label: "Pallet Stack",
      position: { x: 4.946, z: -25.252 },
      size: { w: 1.398, d: 0.799, h: 0.707 },
      color: 0x6f5c3e,
      interactable: false,
      modelUrl: "/models/objects/obj_blocks-stack.glb",
      rotationY: 3.003,
    },
    {
      id: "subway_district-junk-116",
      kind: "prop",
      label: "Tyre Pile",
      position: { x: -5.783, z: 15.484 },
      size: { w: 2.166, d: 1.957, h: 0.917 },
      color: 0x2a2724,
      interactable: false,
      modelUrl: "/models/objects/obj_tyre-pile.glb",
      rotationY: 0.078,
    },
    {
      id: "subway_district-junk-117",
      kind: "prop",
      label: "Tyre Pile",
      position: { x: -27.482, z: 14.158 },
      size: { w: 2.153, d: 1.945, h: 0.912 },
      color: 0x2a2724,
      interactable: false,
      modelUrl: "/models/objects/obj_tyre-pile.glb",
      rotationY: 1.092,
    },
    {
      id: "subway_district-junk-118",
      kind: "prop",
      label: "Cable Spool",
      position: { x: -11.896, z: 16.749 },
      size: { w: 0.548, d: 0.462, h: 0.4 },
      color: 0x5a4d38,
      interactable: false,
      modelUrl: "/models/objects/obj_rope-coil.glb",
      rotationY: 2.36,
      noClip: true,
    },
    {
      id: "subway_district-junk-119",
      kind: "prop",
      label: "Pallet Stack",
      position: { x: 0.366, z: -7.369 },
      size: { w: 1.39, d: 0.795, h: 0.703 },
      color: 0x6f5c3e,
      interactable: false,
      modelUrl: "/models/objects/obj_blocks-stack.glb",
      rotationY: 1.512,
    },
    {
      id: "subway_district-junk-120",
      kind: "prop",
      label: "Cable Spool",
      position: { x: -16.712, z: -10.371 },
      size: { w: 0.493, d: 0.416, h: 0.36 },
      color: 0x5a4d38,
      interactable: false,
      modelUrl: "/models/objects/obj_rope-coil.glb",
      rotationY: 5.534,
      noClip: true,
    },
    {
      id: "subway_district-junk-121",
      kind: "prop",
      label: "Crates",
      position: { x: -9.075, z: -5.567 },
      size: { w: 1.171, d: 1.115, h: 0.644 },
      color: 0x7a6544,
      interactable: false,
      modelUrl: "/models/objects/obj_crates.glb",
      rotationY: 2.2,
    },
    {
      id: "subway_district-junk-122",
      kind: "prop",
      label: "Jersey Barrier",
      position: { x: 27.284, z: 10.818 },
      size: { w: 0.843, d: 2.183, h: 0.829 },
      color: 0x8a8578,
      interactable: false,
      modelUrl: "/models/objects/obj_jersey-barrier.glb",
      rotationY: 1.442,
    },
    {
      id: "subway_district-junk-123",
      kind: "prop",
      label: "Sandbags",
      position: { x: -11.544, z: -7.5 },
      size: { w: 1.96, d: 0.284, h: 0.267 },
      color: 0x7a6d4e,
      interactable: false,
      modelUrl: "/models/objects/obj_sandbag-wall.glb",
      rotationY: 5.841,
    },
    {
      id: "subway_district-junk-124",
      kind: "prop",
      label: "Crates",
      position: { x: -21.448, z: -16.179 },
      size: { w: 1.163, d: 1.107, h: 0.639 },
      color: 0x7a6544,
      interactable: false,
      modelUrl: "/models/objects/obj_crates.glb",
      rotationY: 4.941,
    },
    {
      id: "subway_district-junk-125",
      kind: "prop",
      label: "Crates",
      position: { x: 4.201, z: 10.103 },
      size: { w: 1.441, d: 1.372, h: 0.792 },
      color: 0x7a6544,
      interactable: false,
      modelUrl: "/models/objects/obj_crates.glb",
      rotationY: 5.282,
    },
    {
      id: "subway_district-junk-126",
      kind: "prop",
      label: "Crates",
      position: { x: 7.516, z: 31.624 },
      size: { w: 1.54, d: 1.466, h: 0.846 },
      color: 0x7a6544,
      interactable: false,
      modelUrl: "/models/objects/obj_crates.glb",
      rotationY: 4.292,
    },
    {
      id: "subway_district-junk-127",
      kind: "prop",
      label: "Cable Spool",
      position: { x: -16.824, z: -8.246 },
      size: { w: 0.616, d: 0.519, h: 0.449 },
      color: 0x5a4d38,
      interactable: false,
      modelUrl: "/models/objects/obj_rope-coil.glb",
      rotationY: 4.722,
      noClip: true,
    },
    {
      id: "subway_district-junk-128",
      kind: "prop",
      label: "Sandbags",
      position: { x: -14.959, z: -6.55 },
      size: { w: 1.66, d: 0.241, h: 0.226 },
      color: 0x7a6d4e,
      interactable: false,
      modelUrl: "/models/objects/obj_sandbag-wall.glb",
      rotationY: 3.73,
    },
    {
      id: "subway_district-junk-129",
      kind: "prop",
      label: "Pallet Stack",
      position: { x: -14.073, z: 27.56 },
      size: { w: 1.668, d: 0.954, h: 0.843 },
      color: 0x6f5c3e,
      interactable: false,
      modelUrl: "/models/objects/obj_blocks-stack.glb",
      rotationY: 6.078,
    },
    {
      id: "subway_district-junk-130",
      kind: "prop",
      label: "Cable Spool",
      position: { x: 28.008, z: -4.318 },
      size: { w: 0.567, d: 0.478, h: 0.414 },
      color: 0x5a4d38,
      interactable: false,
      modelUrl: "/models/objects/obj_rope-coil.glb",
      rotationY: 4.19,
      noClip: true,
    },
    {
      id: "subway_district-junk-131",
      kind: "prop",
      label: "Crates",
      position: { x: 28.455, z: -15.451 },
      size: { w: 1.327, d: 1.263, h: 0.729 },
      color: 0x7a6544,
      interactable: false,
      modelUrl: "/models/objects/obj_crates.glb",
      rotationY: 3.162,
    },
    {
      id: "subway_district-junk-132",
      kind: "prop",
      label: "Pallet Stack",
      position: { x: 15.678, z: 21.298 },
      size: { w: 1.61, d: 0.921, h: 0.814 },
      color: 0x6f5c3e,
      interactable: false,
      modelUrl: "/models/objects/obj_blocks-stack.glb",
      rotationY: 5.456,
    },
    {
      id: "subway_district-junk-133",
      kind: "prop",
      label: "Half Barrel",
      position: { x: 18.263, z: -3.745 },
      size: { w: 0.524, d: 0.5, h: 0.478 },
      color: 0x6b5a3c,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel-half.glb",
      rotationY: 5.743,
    },
    {
      id: "subway_district-junk-134",
      kind: "prop",
      label: "Pallet Stack",
      position: { x: -23.324, z: -15.177 },
      size: { w: 1.558, d: 0.891, h: 0.788 },
      color: 0x6f5c3e,
      interactable: false,
      modelUrl: "/models/objects/obj_blocks-stack.glb",
      rotationY: 0.825,
    },
    {
      id: "subway_district-junk-135",
      kind: "prop",
      label: "Cable Spool",
      position: { x: 29.328, z: 3.148 },
      size: { w: 0.478, d: 0.403, h: 0.348 },
      color: 0x5a4d38,
      interactable: false,
      modelUrl: "/models/objects/obj_rope-coil.glb",
      rotationY: 3.382,
      noClip: true,
    },
    {
      id: "subway_district-junk-136",
      kind: "prop",
      label: "Half Barrel",
      position: { x: 18.694, z: -9.869 },
      size: { w: 0.517, d: 0.493, h: 0.472 },
      color: 0x6b5a3c,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel-half.glb",
      rotationY: 2.45,
    },
    {
      id: "subway_district-junk-137",
      kind: "prop",
      label: "Scrap Pile",
      position: { x: 8.152, z: 16.152 },
      size: { w: 1.58, d: 1.359, h: 0.469 },
      color: 0x5d5a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_tarp-roll.glb",
      rotationY: 5.425,
      noClip: true,
      positionY: -0.05,
    },
    {
      id: "subway_district-junk-138",
      kind: "prop",
      label: "Crates",
      position: { x: 30.763, z: 6.456 },
      size: { w: 1.438, d: 1.369, h: 0.79 },
      color: 0x7a6544,
      interactable: false,
      modelUrl: "/models/objects/obj_crates.glb",
      rotationY: 3.604,
    },
    {
      id: "subway_district-junk-139",
      kind: "prop",
      label: "Cable Spool",
      position: { x: 31.57, z: 7.07 },
      size: { w: 0.528, d: 0.445, h: 0.385 },
      color: 0x5a4d38,
      interactable: false,
      modelUrl: "/models/objects/obj_rope-coil.glb",
      rotationY: 0.713,
      noClip: true,
    },
    {
      id: "subway_district-junk-140",
      kind: "prop",
      label: "Barrel",
      position: { x: -0.305, z: 12.987 },
      size: { w: 0.704, d: 0.704, h: 0.945 },
      color: 0x6b5a3c,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel.glb",
      rotationY: 1.492,
    },
    {
      id: "subway_district-junk-141",
      kind: "prop",
      label: "Crates",
      position: { x: -8.02, z: -28.812 },
      size: { w: 1.271, d: 1.21, h: 0.699 },
      color: 0x7a6544,
      interactable: false,
      modelUrl: "/models/objects/obj_crates.glb",
      rotationY: 3.98,
    },
    {
      id: "subway_district-junk-142",
      kind: "prop",
      label: "Jersey Barrier",
      position: { x: 17.257, z: 10.374 },
      size: { w: 0.996, d: 2.578, h: 0.979 },
      color: 0x8a8578,
      interactable: false,
      modelUrl: "/models/objects/obj_jersey-barrier.glb",
      rotationY: 5.305,
    },
    {
      id: "subway_district-junk-143",
      kind: "prop",
      label: "Tyre Pile",
      position: { x: 29.474, z: 0.613 },
      size: { w: 2.025, d: 1.829, h: 0.858 },
      color: 0x2a2724,
      interactable: false,
      modelUrl: "/models/objects/obj_tyre-pile.glb",
      rotationY: 5.912,
    },
    {
      id: "subway_district-junk-144",
      kind: "prop",
      label: "Crates",
      position: { x: -20.907, z: -18.184 },
      size: { w: 1.272, d: 1.211, h: 0.699 },
      color: 0x7a6544,
      interactable: false,
      modelUrl: "/models/objects/obj_crates.glb",
      rotationY: 1.273,
    },
    {
      id: "subway_district-junk-145",
      kind: "prop",
      label: "Half Barrel",
      position: { x: 21.69, z: -8.6 },
      size: { w: 0.605, d: 0.576, h: 0.552 },
      color: 0x6b5a3c,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel-half.glb",
      rotationY: 0.984,
    },
    {
      id: "subway_district-junk-146",
      kind: "prop",
      label: "Scrap Pile",
      position: { x: -20.356, z: -16.843 },
      size: { w: 1.242, d: 1.068, h: 0.369 },
      color: 0x5d5a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_tarp-roll.glb",
      rotationY: 2.274,
      noClip: true,
      positionY: -0.05,
    },
    {
      id: "subway_district-junk-147",
      kind: "prop",
      label: "Scrap Pile",
      position: { x: 10.777, z: -15.174 },
      size: { w: 1.186, d: 1.02, h: 0.352 },
      color: 0x5d5a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_tarp-roll.glb",
      rotationY: 0.09,
      noClip: true,
      positionY: -0.05,
    },
    {
      id: "subway_district-junk-148",
      kind: "prop",
      label: "Barrel",
      position: { x: 4.063, z: -24.144 },
      size: { w: 0.816, d: 0.816, h: 1.095 },
      color: 0x6b5a3c,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel.glb",
      rotationY: 4.608,
    },
    {
      id: "subway_district-junk-149",
      kind: "prop",
      label: "Scrap Pile",
      position: { x: 31.767, z: 5.32 },
      size: { w: 1.561, d: 1.343, h: 0.463 },
      color: 0x5d5a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_tarp-roll.glb",
      rotationY: 2.073,
      noClip: true,
      positionY: -0.05,
    },
    {
      id: "subway_district-junk-150",
      kind: "prop",
      label: "Jersey Barrier",
      position: { x: 9.355, z: 1.496 },
      size: { w: 0.77, d: 1.993, h: 0.756 },
      color: 0x8a8578,
      interactable: false,
      modelUrl: "/models/objects/obj_jersey-barrier.glb",
      rotationY: 3.723,
    },
    {
      id: "subway_district-junk-151",
      kind: "prop",
      label: "Tyre Pile",
      position: { x: 19.575, z: -21.55 },
      size: { w: 2.469, d: 2.23, h: 1.045 },
      color: 0x2a2724,
      interactable: false,
      modelUrl: "/models/objects/obj_tyre-pile.glb",
      rotationY: 3.81,
    },
    {
      id: "subway_district-junk-152",
      kind: "prop",
      label: "Sandbags",
      position: { x: 14.231, z: 3.998 },
      size: { w: 2.053, d: 0.298, h: 0.28 },
      color: 0x7a6d4e,
      interactable: false,
      modelUrl: "/models/objects/obj_sandbag-wall.glb",
      rotationY: 2.592,
    },
    {
      id: "subway_district-junk-153",
      kind: "prop",
      label: "Jersey Barrier",
      position: { x: -29.227, z: 8.031 },
      size: { w: 0.884, d: 2.288, h: 0.868 },
      color: 0x8a8578,
      interactable: false,
      modelUrl: "/models/objects/obj_jersey-barrier.glb",
      rotationY: 5.38,
    },
    {
      id: "subway_district-junk-154",
      kind: "prop",
      label: "Crates",
      position: { x: 8.821, z: 18.543 },
      size: { w: 1.19, d: 1.133, h: 0.654 },
      color: 0x7a6544,
      interactable: false,
      modelUrl: "/models/objects/obj_crates.glb",
      rotationY: 2.2,
    },
    {
      id: "subway_district-junk-155",
      kind: "prop",
      label: "Scrap Pile",
      position: { x: -1.871, z: -24.111 },
      size: { w: 1.555, d: 1.337, h: 0.462 },
      color: 0x5d5a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_tarp-roll.glb",
      rotationY: 1.146,
      noClip: true,
      positionY: -0.05,
    },
    {
      id: "subway_district-junk-157",
      kind: "prop",
      label: "Dumpster",
      position: { x: -31.13, z: -5.872 },
      size: { w: 2.201, d: 1.749, h: 1.575 },
      color: 0x3f5546,
      interactable: false,
      modelUrl: "/models/objects/obj_dumpster.glb",
      rotationY: 0.862,
    },
    {
      id: "subway_district-junk-158",
      kind: "prop",
      label: "Barrel",
      position: { x: 2.734, z: -14.461 },
      size: { w: 0.804, d: 0.804, h: 1.079 },
      color: 0x6b5a3c,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel.glb",
      rotationY: 2.544,
    },
    {
      id: "subway_district-junk-159",
      kind: "prop",
      label: "Tyre Pile",
      position: { x: 9.349, z: 27.857 },
      size: { w: 2.188, d: 1.977, h: 0.927 },
      color: 0x2a2724,
      interactable: false,
      modelUrl: "/models/objects/obj_tyre-pile.glb",
      rotationY: 3.351,
    },
    {
      id: "subway_district-junk-160",
      kind: "prop",
      label: "Tyre Pile",
      position: { x: -10.743, z: 28.581 },
      size: { w: 2.362, d: 2.133, h: 1 },
      color: 0x2a2724,
      interactable: false,
      modelUrl: "/models/objects/obj_tyre-pile.glb",
      rotationY: 4.559,
    },
    {
      id: "subway_district-junk-161",
      kind: "prop",
      label: "Jersey Barrier",
      position: { x: -9.236, z: 24.685 },
      size: { w: 0.911, d: 2.357, h: 0.895 },
      color: 0x8a8578,
      interactable: false,
      modelUrl: "/models/objects/obj_jersey-barrier.glb",
      rotationY: 2.196,
    },
    {
      id: "subway_district-junk-162",
      kind: "prop",
      label: "Pallet Stack",
      position: { x: 24.356, z: -5.758 },
      size: { w: 1.556, d: 0.89, h: 0.787 },
      color: 0x6f5c3e,
      interactable: false,
      modelUrl: "/models/objects/obj_blocks-stack.glb",
      rotationY: 5.13,
    },
    {
      id: "subway_district-junk-163",
      kind: "prop",
      label: "Barrel",
      position: { x: 0.896, z: 15.673 },
      size: { w: 0.6, d: 0.6, h: 0.806 },
      color: 0x6b5a3c,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel.glb",
      rotationY: 3.605,
    },
    {
      id: "subway_district-junk-164",
      kind: "prop",
      label: "Cable Spool",
      position: { x: 12.684, z: 5.727 },
      size: { w: 0.552, d: 0.465, h: 0.402 },
      color: 0x5a4d38,
      interactable: false,
      modelUrl: "/models/objects/obj_rope-coil.glb",
      rotationY: 5.949,
      noClip: true,
    },
    {
      id: "subway_district-junk-165",
      kind: "prop",
      label: "Half Barrel",
      position: { x: 9.786, z: 17.356 },
      size: { w: 0.493, d: 0.47, h: 0.449 },
      color: 0x6b5a3c,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel-half.glb",
      rotationY: 3.085,
    },
    {
      id: "subway_district-junk-166",
      kind: "prop",
      label: "Sandbags",
      position: { x: 2.741, z: -26.008 },
      size: { w: 1.489, d: 0.216, h: 0.203 },
      color: 0x7a6d4e,
      interactable: false,
      modelUrl: "/models/objects/obj_sandbag-wall.glb",
      rotationY: 5.234,
    },
    {
      id: "subway_district-junk-167",
      kind: "prop",
      label: "Half Barrel",
      position: { x: 31.23, z: 8.915 },
      size: { w: 0.538, d: 0.513, h: 0.491 },
      color: 0x6b5a3c,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel-half.glb",
      rotationY: 2.052,
    },
    {
      id: "subway_district-junk-168",
      kind: "prop",
      label: "Scrap Pile",
      position: { x: -27.307, z: -6.422 },
      size: { w: 1.349, d: 1.16, h: 0.401 },
      color: 0x5d5a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_tarp-roll.glb",
      rotationY: 5.681,
      noClip: true,
      positionY: -0.05,
    },
    {
      id: "subway_district-junk-169",
      kind: "prop",
      label: "Tyre Pile",
      position: { x: -17.76, z: -13.568 },
      size: { w: 1.805, d: 1.63, h: 0.764 },
      color: 0x2a2724,
      interactable: false,
      modelUrl: "/models/objects/obj_tyre-pile.glb",
      rotationY: 5.025,
    },
    {
      id: "subway_district-junk-170",
      kind: "prop",
      label: "Pallet Stack",
      position: { x: 11.969, z: -30.172 },
      size: { w: 1.579, d: 0.903, h: 0.798 },
      color: 0x6f5c3e,
      interactable: false,
      modelUrl: "/models/objects/obj_blocks-stack.glb",
      rotationY: 5.433,
    },
    {
      id: "subway_district-junk-171",
      kind: "prop",
      label: "Half Barrel",
      position: { x: 21.521, z: -1.914 },
      size: { w: 0.636, d: 0.607, h: 0.581 },
      color: 0x6b5a3c,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel-half.glb",
      rotationY: 5.939,
    },
    {
      id: "subway_district-junk-172",
      kind: "prop",
      label: "Tyre Pile",
      position: { x: -4.113, z: -20.956 },
      size: { w: 2.431, d: 2.196, h: 1.03 },
      color: 0x2a2724,
      interactable: false,
      modelUrl: "/models/objects/obj_tyre-pile.glb",
      rotationY: 3.527,
    },
    {
      id: "subway_district-junk-173",
      kind: "prop",
      label: "Sandbags",
      position: { x: -5.363, z: -29.737 },
      size: { w: 2.012, d: 0.292, h: 0.274 },
      color: 0x7a6d4e,
      interactable: false,
      modelUrl: "/models/objects/obj_sandbag-wall.glb",
      rotationY: 3.982,
    },
    {
      id: "subway_district-junk-174",
      kind: "prop",
      label: "Barrel",
      position: { x: 7.727, z: 20.871 },
      size: { w: 0.806, d: 0.806, h: 1.082 },
      color: 0x6b5a3c,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel.glb",
      rotationY: 1.237,
    },
    {
      id: "subway_district-junk-175",
      kind: "prop",
      label: "Barrel",
      position: { x: -31.516, z: -2.591 },
      size: { w: 0.79, d: 0.79, h: 1.06 },
      color: 0x6b5a3c,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel.glb",
      rotationY: 4.242,
    },
    {
      id: "subway_district-junk-176",
      kind: "prop",
      label: "Half Barrel",
      position: { x: -7.753, z: 21.468 },
      size: { w: 0.55, d: 0.524, h: 0.502 },
      color: 0x6b5a3c,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel-half.glb",
      rotationY: 5.409,
    },
    {
      id: "subway_district-junk-177",
      kind: "prop",
      label: "Tyre Pile",
      position: { x: -25.658, z: -2.667 },
      size: { w: 2.014, d: 1.819, h: 0.853 },
      color: 0x2a2724,
      interactable: false,
      modelUrl: "/models/objects/obj_tyre-pile.glb",
      rotationY: 0.658,
    },
    {
      id: "subway_district-junk-178",
      kind: "prop",
      label: "Barrel",
      position: { x: -17.703, z: -7.478 },
      size: { w: 0.763, d: 0.763, h: 1.024 },
      color: 0x6b5a3c,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel.glb",
      rotationY: 0.505,
    },
    {
      id: "subway_district-junk-179",
      kind: "prop",
      label: "Cable Spool",
      position: { x: -20.082, z: -5.335 },
      size: { w: 0.555, d: 0.468, h: 0.405 },
      color: 0x5a4d38,
      interactable: false,
      modelUrl: "/models/objects/obj_rope-coil.glb",
      rotationY: 5.517,
      noClip: true,
    },
    {
      id: "subway_district-junk-180",
      kind: "prop",
      label: "Crates",
      position: { x: -13.215, z: 3.059 },
      size: { w: 1.312, d: 1.249, h: 0.721 },
      color: 0x7a6544,
      interactable: false,
      modelUrl: "/models/objects/obj_crates.glb",
      rotationY: 4.308,
    },
    {
      id: "subway_district-junk-181",
      kind: "prop",
      label: "Dumpster",
      position: { x: -5.901, z: 21.926 },
      size: { w: 2.071, d: 1.646, h: 1.482 },
      color: 0x3f5546,
      interactable: false,
      modelUrl: "/models/objects/obj_dumpster.glb",
      rotationY: 3.286,
    },
    {
      id: "subway_district-junk-183",
      kind: "prop",
      label: "Barrel",
      position: { x: 10.271, z: 15.215 },
      size: { w: 0.756, d: 0.756, h: 1.015 },
      color: 0x6b5a3c,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel.glb",
      rotationY: 6.094,
    },
    {
      id: "subway_district-junk-184",
      kind: "prop",
      label: "Tyre Pile",
      position: { x: 16.906, z: -19.117 },
      size: { w: 1.864, d: 1.684, h: 0.79 },
      color: 0x2a2724,
      interactable: false,
      modelUrl: "/models/objects/obj_tyre-pile.glb",
      rotationY: 2.37,
    },
    {
      id: "subway_district-junk-185",
      kind: "prop",
      label: "Half Barrel",
      position: { x: 8.654, z: 30.094 },
      size: { w: 0.607, d: 0.579, h: 0.554 },
      color: 0x6b5a3c,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel-half.glb",
      rotationY: 4.931,
    },
    {
      id: "subway_district-junk-186",
      kind: "prop",
      label: "Dumpster",
      position: { x: 28.42, z: 12.555 },
      size: { w: 1.794, d: 1.426, h: 1.284 },
      color: 0x3f5546,
      interactable: false,
      modelUrl: "/models/objects/obj_dumpster.glb",
      rotationY: 3.374,
    },
    {
      id: "subway_district-junk-187",
      kind: "prop",
      label: "Crates",
      position: { x: 32.379, z: 2.38 },
      size: { w: 1.519, d: 1.446, h: 0.835 },
      color: 0x7a6544,
      interactable: false,
      modelUrl: "/models/objects/obj_crates.glb",
      rotationY: 4.051,
    },
    {
      id: "subway_district-junk-188",
      kind: "prop",
      label: "Cable Spool",
      position: { x: 27.321, z: -13.04 },
      size: { w: 0.514, d: 0.434, h: 0.375 },
      color: 0x5a4d38,
      interactable: false,
      modelUrl: "/models/objects/obj_rope-coil.glb",
      rotationY: 0.243,
      noClip: true,
    },
    {
      id: "subway_district-junk-189",
      kind: "prop",
      label: "Cable Spool",
      position: { x: 13.879, z: -27.154 },
      size: { w: 0.551, d: 0.464, h: 0.402 },
      color: 0x5a4d38,
      interactable: false,
      modelUrl: "/models/objects/obj_rope-coil.glb",
      rotationY: 1.2,
      noClip: true,
    },
    {
      id: "subway_district-junk-190",
      kind: "prop",
      label: "Half Barrel",
      position: { x: 29.64, z: 11.775 },
      size: { w: 0.518, d: 0.494, h: 0.472 },
      color: 0x6b5a3c,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel-half.glb",
      rotationY: 5.591,
    },
    {
      id: "subway_district-junk-191",
      kind: "prop",
      label: "Dumpster",
      position: { x: -5.325, z: -23.297 },
      size: { w: 2.244, d: 1.783, h: 1.606 },
      color: 0x3f5546,
      interactable: false,
      modelUrl: "/models/objects/obj_dumpster.glb",
      rotationY: 1.757,
    },
    {
      id: "subway_district-junk-192",
      kind: "prop",
      label: "Barrel",
      position: { x: 8.803, z: -12.498 },
      size: { w: 0.653, d: 0.653, h: 0.877 },
      color: 0x6b5a3c,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel.glb",
      rotationY: 0.638,
    },
    {
      id: "subway_district-junk-193",
      kind: "prop",
      label: "Barrel",
      position: { x: 4.346, z: 12.78 },
      size: { w: 0.642, d: 0.642, h: 0.862 },
      color: 0x6b5a3c,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel.glb",
      rotationY: 3.539,
    },
    {
      id: "subway_district-junk-194",
      kind: "prop",
      label: "Dumpster",
      position: { x: -3.342, z: -32.75 },
      size: { w: 2.472, d: 1.964, h: 1.769 },
      color: 0x3f5546,
      interactable: false,
      modelUrl: "/models/objects/obj_dumpster.glb",
      rotationY: 3.457,
    },
    {
      id: "subway_district-junk-195",
      kind: "prop",
      label: "Crates",
      position: { x: 18.938, z: 3.934 },
      size: { w: 1.595, d: 1.519, h: 0.877 },
      color: 0x7a6544,
      interactable: false,
      modelUrl: "/models/objects/obj_crates.glb",
      rotationY: 3.795,
    },
    {
      id: "subway_district-junk-196",
      kind: "prop",
      label: "Cable Spool",
      position: { x: -22.766, z: 22.089 },
      size: { w: 0.557, d: 0.47, h: 0.406 },
      color: 0x5a4d38,
      interactable: false,
      modelUrl: "/models/objects/obj_rope-coil.glb",
      rotationY: 5.464,
      noClip: true,
    },
    {
      id: "subway_district-junk-197",
      kind: "prop",
      label: "Barrel",
      position: { x: 30.186, z: -2.084 },
      size: { w: 0.697, d: 0.697, h: 0.935 },
      color: 0x6b5a3c,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel.glb",
      rotationY: 4.433,
    },
    {
      id: "subway_district-junk-198",
      kind: "prop",
      label: "Half Barrel",
      position: { x: -17.11, z: 24.754 },
      size: { w: 0.587, d: 0.56, h: 0.536 },
      color: 0x6b5a3c,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel-half.glb",
      rotationY: 4.627,
    },
    {
      id: "subway_district-junk-199",
      kind: "prop",
      label: "Scrap Pile",
      position: { x: 4.637, z: -13.461 },
      size: { w: 1.32, d: 1.135, h: 0.392 },
      color: 0x5d5a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_tarp-roll.glb",
      rotationY: 0.272,
      noClip: true,
      positionY: -0.05,
    },
    {
      id: "subway_district-junk-200",
      kind: "prop",
      label: "Cable Spool",
      position: { x: 23.25, z: 18.985 },
      size: { w: 0.507, d: 0.428, h: 0.37 },
      color: 0x5a4d38,
      interactable: false,
      modelUrl: "/models/objects/obj_rope-coil.glb",
      rotationY: 4.499,
      noClip: true,
    },
    {
      id: "subway_district-junk-201",
      kind: "prop",
      label: "Half Barrel",
      position: { x: -4.55, z: 13.063 },
      size: { w: 0.595, d: 0.568, h: 0.543 },
      color: 0x6b5a3c,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel-half.glb",
      rotationY: 3.123,
    },
    {
      id: "subway_district-junk-202",
      kind: "prop",
      label: "Barrel",
      position: { x: 16.027, z: -28.15 },
      size: { w: 0.755, d: 0.755, h: 1.013 },
      color: 0x6b5a3c,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel.glb",
      rotationY: 5.204,
    },
    {
      id: "subway_district-junk-203",
      kind: "prop",
      label: "Half Barrel",
      position: { x: -16.902, z: -12.397 },
      size: { w: 0.472, d: 0.45, h: 0.43 },
      color: 0x6b5a3c,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel-half.glb",
      rotationY: 1.844,
    },
    {
      id: "subway_district-junk-204",
      kind: "prop",
      label: "Barrel",
      position: { x: -24.905, z: -7.02 },
      size: { w: 0.647, d: 0.647, h: 0.868 },
      color: 0x6b5a3c,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel.glb",
      rotationY: 2.046,
    },
    {
      id: "subway_district-junk-205",
      kind: "prop",
      label: "Barrel",
      position: { x: -18.886, z: 25.765 },
      size: { w: 0.613, d: 0.613, h: 0.822 },
      color: 0x6b5a3c,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel.glb",
      rotationY: 2.355,
    },
    {
      id: "subway_district-junk-207",
      kind: "prop",
      label: "Cable Spool",
      position: { x: 11.253, z: 6.592 },
      size: { w: 0.605, d: 0.51, h: 0.441 },
      color: 0x5a4d38,
      interactable: false,
      modelUrl: "/models/objects/obj_rope-coil.glb",
      rotationY: 4.987,
      noClip: true,
    },
    {
      id: "subway_district-junk-208",
      kind: "prop",
      label: "Scrap Pile",
      position: { x: 11.217, z: 29.795 },
      size: { w: 1.174, d: 1.01, h: 0.348 },
      color: 0x5d5a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_tarp-roll.glb",
      rotationY: 2.702,
      noClip: true,
      positionY: -0.05,
    },
    {
      id: "subway_district-junk-209",
      kind: "prop",
      label: "Pallet Stack",
      position: { x: -28.97, z: 5.696 },
      size: { w: 1.682, d: 0.962, h: 0.851 },
      color: 0x6f5c3e,
      interactable: false,
      modelUrl: "/models/objects/obj_blocks-stack.glb",
      rotationY: 0.243,
    },
    {
      id: "subway_district-junk-210",
      kind: "prop",
      label: "Barrel",
      position: { x: 16.645, z: -25.441 },
      size: { w: 0.806, d: 0.806, h: 1.082 },
      color: 0x6b5a3c,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel.glb",
      rotationY: 3.552,
    },
  ],

  collisionZones: [
    {
      id: "edge-n",
      label: "Ridge",
      position: { x: 0, z: -37 },
      size: { w: 76, d: 2 },
    },
    {
      id: "edge-s",
      label: "Ridge",
      position: { x: 0, z: 37 },
      size: { w: 76, d: 2 },
    },
    {
      id: "edge-w",
      label: "Ridge",
      position: { x: -37, z: 0 },
      size: { w: 2, d: 76 },
    },
    {
      id: "edge-e",
      label: "Ridge",
      position: { x: 37, z: 0 },
      size: { w: 2, d: 76 },
    },
    {
      id: "fog-1",
      label: "Low Fog",
      position: { x: -1.4, z: -16.11 },
      size: { w: 20.387204471975565, d: 18.5233067702502 },
      blocksVision: true,
      blocksMovement: false,
      fog: { color: 8227471, opacity: 0.4, height: 3.4 },
    },
    {
      id: "fog-2",
      label: "Low Fog",
      position: { x: -20.85, z: 15.81 },
      size: { w: 17.09040319174528, d: 13.488584648817778 },
      blocksVision: true,
      blocksMovement: false,
      fog: { color: 8227471, opacity: 0.4, height: 3.4 },
    },
    {
      id: "fog-3",
      label: "Low Fog",
      position: { x: -24.56, z: -23.32 },
      size: { w: 16.852085638791323, d: 19.256237925961614 },
      blocksVision: true,
      blocksMovement: false,
      fog: { color: 8227471, opacity: 0.4, height: 3.4 },
    },
  ],

  roads: [
    {
      id: "sd-concourse",
      label: "Concourse",
      surface: "asphalt_old",
      points: [{ x: -34, z: 26 }, { x: 30, z: -24 }],
      width: 5.248,
      opacity: 0.6,
    },
    {
      id: "sd-service",
      label: "Service Path",
      surface: "dirt_path",
      points: [{ x: 28, z: 28 }, { x: -26, z: -28 }],
      width: 3.936,
      opacity: 0.6,
    },
  ],

  npcs: {
  },

  dialog: {
  },
};
